import React from 'react'
import { useTranslation } from 'react-i18next';

import SelectForm from './SelectForm'


type Options = {
    label: string;
    value: string;
};

interface InputProps {
    formClass?: string
    iconClass?: string
    iconName?: string
    inputClass?: string
    inputContainerClass?: string
    inputStyle?: React.CSSProperties
    inputType: string
    inputValue?: string
    onChange(event: React.ChangeEvent<HTMLInputElement>): any
    onFocus?: React.FocusEventHandler<HTMLInputElement>
    placeholderValue?: string
    iconContainer: string
    setFilter?: React.Dispatch<React.SetStateAction<string | undefined>>
    filter?: boolean
    fiterOption?: Options[]
}



const SearchInput = (props: InputProps) => {
    const { t } = useTranslation();
    const {
        formClass,
        iconClass,
        inputClass,
        inputContainerClass,
        inputStyle,
        inputType,
        inputValue,
        onChange,
        onFocus,
        placeholderValue,
        iconContainer,
        setFilter,
        filter,
        fiterOption
    } = props

    return (
        <div className={inputContainerClass}>
            <div
                className={`famla-search-input input-group ${formClass ?? ''}`.trim()}
                style={inputStyle}
            >
                <span className={`input-group-text ${iconContainer}`} id="basic-addon1">
                    <i className={iconClass}></i>
                </span>
                <input
                    onChange={onChange}
                    onFocus={onFocus}
                    type={inputType}
                    className={`custom-input ${inputClass ?? ''}`.trim()}
                    placeholder={placeholderValue}
                    value={inputValue}
                    aria-label={placeholderValue ?? 'Search'}
                    aria-describedby="basic-addon1"
                />
                 {/* {filter &&
                    <SelectForm
                        selectClass="px-1 py-1 m-0 border-0 newbg-black h-100  border border-0"
                        placeholder={t('words.filter')}
                        selectName='selectName'
                        selectOptions={fiterOption ?? []}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => setFilter?.(event.target.value)}
                    />
                }  */}
            </div>
        </div>
    )
}
export default SearchInput